import { NO_SELECTED_MODEL_FOUND_WARNING } from 'Common/components/FilterByMultiSelect/consts';
import { MODEL_DEFINITIONS_COLLECTION } from 'Common/consts/modelDefinitions';
import { logger } from 'Common/utils';
import { EMPTY_MODEL } from '../../consts';
/**
 * getSelectedModel util:
 *
 * @param modelName Models name
 * @returns Object with model and definition properties
 */
const getSelectedModel = (modelName) => {
    const selectedModel = MODEL_DEFINITIONS_COLLECTION[modelName];
    if (!selectedModel) {
        logger.warn(NO_SELECTED_MODEL_FOUND_WARNING);
        return EMPTY_MODEL;
    }
    return selectedModel;
};
export default getSelectedModel;
